import { InspectionAsset } from './InspectionAsset';
import { User } from './User';

export interface Inspection {
  id: number;
  userId: number | null;
  typeId: number | null;
  mileage: number | null;
  dateCreated: string | null;

  inspectionAssets: InspectionAsset[] | [];
  user: User | null;
}

export enum InspectionTypeEnum {
  Pre = 1,
  Post = 2,
}
